<template>
  <v-container fluid>
    <v-row shrink dense class="ma-0">
      <v-subheader v-if="buildingTemplate">
        Numeric attributes
      </v-subheader>
      <v-col cols="12" class="pa-0">
        <v-card
          flat
          class="ma-0 pa-0"
          min-width="400px"
          v-if="otherWidgets.length"
        >
          <draggable
            v-if="buildingTemplate"
            class="dragArea list-group"
            :list="otherWidgets"
            @end="saveOrder(otherWidgets)"
          >
            <v-col
              v-for="item in otherWidgets"
              :key="item.id"
              cols="4"
              sm="12"
              md="6"
              lg="4"
              class="pa-2"
            >
              <v-card class="ma-0 pa-0">
                <v-container>
                  <v-row hover dense class="pa-2 ma-0 subtitle-1">
                    <v-col cols="1" v-if="item.attDisplayValue == null">
                      <v-btn icon>
                        <v-icon size="22" dark
                          >mdi-drag-horizontal-variant</v-icon
                        >
                      </v-btn>
                    </v-col>
                    <v-col cols="3" sm="0" md="4" lg="3">
                      <v-card flat class="pa-2" min-width="50px">
                        <v-img
                          class="v-window-item"
                          :src="item.widgetUrl"
                          contain
                          style="height:60px;width:100%"
                        ></v-img>
                      </v-card>
                    </v-col>
                    <v-col>
                      <v-row dense class="title font-weight-medium">
                        {{ item.attribute.name }}
                      </v-row>
                      <v-row dense>
                        <p v-line-clamp="5">Value</p>
                      </v-row>
                    </v-col>
                    <v-col cols="2" v-if="item.attDisplayValue == null">
                      <v-btn icon v-on:click="UpdateThumbnail(item)">
                        <v-icon size="22" dark>mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn icon v-on:click="DeleteWidget(item)">
                        <v-icon size="22" dark>mdi-delete</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </draggable>
          <v-data-iterator
            v-else
            class="pa-2"
            :items="otherWidgets"
            dense
            hide-default-footer
          >
            <template v-slot:default="props">
              <v-row>
                <v-col
                  v-for="(item, index) in props.items"
                  :key="index"
                  cols="3"
                  sm="12"
                  md="6"
                  lg="3"
                  class="pa-2"
                >
                  <v-card class="ma-0 pa-0">
                    <v-container>
                      <v-row hover dense class="pa-2 ma-0 subtitle-1">
                        <v-col cols="3" sm="0" md="4" lg="3">
                          <v-card flat class="pa-2" min-width="50px">
                            <v-img
                              class="v-window-item"
                              :src="item.widgetUrl"
                              contain
                              style="height:60px;width:100%"
                            ></v-img>
                          </v-card>
                        </v-col>
                        <v-col>
                          <v-row dense class="title font-weight-medium">
                            {{ item.attribute.name }}
                          </v-row>
                          <v-row dense>
                            <p v-line-clamp="5">
                              {{
                                (item.attDisplayValue != null
                                  ? item.attDisplayValue
                                  : "Value") +
                                  (item.units != null ? " " + item.units : "")
                              }}
                            </p>
                          </v-row>
                        </v-col>
                        <v-col cols="2" v-if="item.attDisplayValue == null">
                          <v-btn icon v-on:click="UpdateThumbnail(item)">
                            <v-icon size="22" dark>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn icon v-on:click="DeleteWidget(item)">
                            <v-icon size="22" dark>mdi-delete</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
            </template>
          </v-data-iterator>
        </v-card>
      </v-col>
      <v-subheader v-if="buildingTemplate">
        Multiple choice attributes
      </v-subheader>
      <v-col cols="12" class="pa-0">
        <v-card
          flat
          class="ma-0 pa-0"
          min-width="400px"
          v-if="multiWidgets.length"
        >
          <draggable
            v-if="buildingTemplate"
            class="dragArea list-group"
            :list="multiWidgets"
            @end="saveOrder(multiWidgets)"
          >
            <v-col
              v-for="item in multiWidgets"
              :key="item.id"
              cols="4"
              sm="12"
              md="6"
              lg="4"
              class="pa-2"
            >
              <v-card class="ma-0 pa-0">
                <v-container>
                  <v-row hover dense class="pa-2 ma-0 subtitle-1">
                    <v-col cols="1" v-if="item.attDisplayValue == null">
                      <v-btn icon>
                        <v-icon size="22" dark
                          >mdi-drag-horizontal-variant</v-icon
                        >
                      </v-btn>
                    </v-col>
                    <v-col cols="3" sm="0" md="4" lg="3">
                      <v-card flat class="pa-2" min-width="50px">
                        <v-img
                          class="v-window-item"
                          :src="
                            item.widgetUrl.length > 0
                              ? item.widgetUrl
                              : 'https://activstoredev.blob.core.windows.net/test/box.png'
                          "
                          contain
                          style="height:60px;width:100%"
                        ></v-img>
                      </v-card>
                    </v-col>
                    <v-col>
                      <v-row dense class="title font-weight-medium">
                        {{ item.attribute.name }}
                      </v-row>
                      <v-row dense>
                        <p v-line-clamp="5">Value</p>
                      </v-row>
                    </v-col>
                    <v-col cols="2" v-if="item.attDisplayValue == null">
                      <v-btn icon v-on:click="UpdateThumbnail(item)">
                        <v-icon size="22" dark>mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn icon v-on:click="DeleteWidget(item)">
                        <v-icon size="22" dark>mdi-delete</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </draggable>
          <v-data-iterator
            v-else
            class="pa-2"
            :items="multiWidgets"
            dense
            hide-default-footer
          >
            <template v-slot:default="props">
              <v-row>
                <v-col
                  v-for="(item, index) in props.items"
                  :key="index"
                  cols="6"
                  sm="12"
                  md="12"
                  lg="6"
                  class="pa-3"
                >
                  <v-card class="ma-0 pa-0">
                    <v-container>
                      <v-row hover dense class="pa-2 ma-0 subtitle-1">
                        <v-col cols="2" sm="0" md="1" lg="2">
                          <v-card flat class="pa-2" min-width="50px">
                            <v-img
                              class="v-window-item"
                              :src="
                                item.widgetUrl.length > 0
                                  ? item.widgetUrl
                                  : 'https://activstoredev.blob.core.windows.net/test/box.png'
                              "
                              contain
                              style="height:60px;width:100%"
                            ></v-img>
                          </v-card>
                        </v-col>
                        <v-col>
                          <v-row dense class="title font-weight-medium">
                            {{ item.attribute.name }}
                          </v-row>
                          <v-row dense>
                            <p v-line-clamp="5">
                              {{
                                item.attDisplayValue != null
                                  ? item.attDisplayValue
                                  : "Value"
                              }}
                            </p>
                          </v-row>
                        </v-col>
                        <v-col cols="2" v-if="item.attDisplayValue == null">
                          <v-btn icon v-on:click="UpdateThumbnail(item)">
                            <v-icon size="22" dark>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn icon v-on:click="DeleteWidget(item)">
                            <v-icon size="22" dark>mdi-delete</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
            </template>
          </v-data-iterator>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="confirmDeleteDialog" max-width="400px">
      <v-card>
        <v-card color="primaryDark" dark flat class="pa-3 subtitle-1">
          Delete Widget
        </v-card>
        <v-card-text class="pt-4">
          Are you sure you want to delete this widget?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="confirmDeleteDialog = false">
            Cancel
          </v-btn>
          <v-btn color="red" dark @click="ConfirmDeleteWidget()">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import draggable from "vuedraggable";

export default {
  name: "AttributeWidgetTemplate",
  components: {
    draggable,
  },
  props: {
    //Attributes that currently have a widget
    attributeWidgets: {
      default: null,
      type: Array,
    },
    //Are we currently editing a template?
    buildingTemplate: {
      default: false,
      type: Boolean,
    },
  },
  mounted() {
    if (this.attributeWidgets.length) {
      this.multiWidgets = this.attributeWidgets.filter(
        (i) => i.attribute.type == "Multi"
      );
      this.otherWidgets = this.attributeWidgets.filter(
        (i) => i.attribute.type != "Multi"
      );
    }
  },
  computed: {
    ...mapState("assetxpstate", ["section"]),
  },
  data: () => ({
    orderingWidgets: false,
    lines: 2,
    attributesPerPage: 8,
    itemsPerPageOptions: [2, 4, 8],
    multiWidgets: [],
    otherWidgets: [],
    confirmDeleteDialog: false,
    widgetPendingDelete: null,
  }),
  methods: {
    ...mapGetters("authentication", ["CanUserEditAssets", "GetAuthHeaderObj"]),
    ...mapActions("assetxpstate", [
      "DeleteWidgetFromTemplate",
      "UpdateWidgetThumbnail",
      "OrderWidgets",
    ]),

    DeleteWidget(widget) {
      this.widgetPendingDelete = widget;
      this.confirmDeleteDialog = true;
    },
    ConfirmDeleteWidget() {
      this.confirmDeleteDialog = false;
      const widget = this.widgetPendingDelete;
      this.widgetPendingDelete = null;

      if (widget) {
        this.DeleteWidgetFromTemplate(widget.id).then(() => {
          this.$emit("widgetDeleted", widget);
        });
      }
    },
    UpdateThumbnail(widget) {
      this.$emit("updateWidget", widget);
    },
    saveOrder(widgets) {
      this.orderingWidgets = true;

      this.OrderWidgets(widgets).then((response) => {
        this.orderingWidgets = false;
      });
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }

        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
      }

      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;

        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }

        // Thumbnails
        newFile.thumb = "";

        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
    },
  },
  watch: {
    attributeWidgets() {
      if (this.attributeWidgets.length) {
        this.multiWidgets = this.attributeWidgets.filter(
          (i) => i.attribute.type == "Multi"
        );
        this.otherWidgets = this.attributeWidgets.filter(
          (i) => i.attribute.type != "Multi"
        );
      }
    },
  },
};
</script>

<style scoped>
.v-btn {
  width: 30px;
  height: 30px;
  margin: 0px;
  padding: 0px;
}
.cardContent {
  margin: 0px;
  padding: 5px;
}
</style>
